import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { settingsStoreToken } from '../../../../../cross-team-shared/state/setting-state';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';

export const EVEN_SPLIT_TEXT = 'Split view: 50%';
export const UNEVEN_SPLIT_TEXT = 'Split view: 60-40% (dynamic)';
@Component({
  selector: 'h3-layout-settings',
  templateUrl: './layout-settings.component.html',
  styleUrl: './layout-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LayoutSettingsComponent {
  private readonly eventTrackingService = inject(EventTrackingService);
  private readonly settingsStore = inject(settingsStoreToken);
  layoutStore = this.settingsStore('useEvenSplit');
  buttons = [
    { value: true, icon: 'even_split', text: EVEN_SPLIT_TEXT },
    { value: false, icon: 'uneven_split', text: UNEVEN_SPLIT_TEXT },
  ];

  changeLayout(useEvenSplit: boolean) {
    if (useEvenSplit === this.layoutStore.state()) {
      return;
    }
    this.layoutStore.set(useEvenSplit);
    this.eventTrackingService.track({
      id: 'change_layout_style',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: useEvenSplit ? '50/50' : '60/40',
    });
  }
}
